<template>
  <v-container class="pt-12">
    <v-row class="align-center">
      <v-col cols="3"></v-col>
      <v-col cols="3" class="pr-0">
        <v-card
          max-width="100%"
          height="300"
          color="#feb100"
          style="border-radius: 0px"
        >
          <v-card-title class="font-futura-subtitle">
            {{ $t("my-commercial") }}
          </v-card-title>
          <v-card-text>
            <div
              v-if="uniqueContactDetails"
              class="font-egyptienne"
            >
              <div class="text-h6 font-weight-bold mb-2 mt-5">
                {{ uniqueContactDetails.firstName }}
                {{ uniqueContactDetails.lastName }}
              </div>
              <div v-if="uniqueContactDetails.email" class="mb-1">
                <v-icon small class="mr-2" :size="20">
                  {{ mdiEmail }}
                </v-icon>
                <span class="text-subtitle-2">
                  {{ uniqueContactDetails.email }}
                </span>
              </div>
            </div>
            <!-- <div
              v-else
              class="text-center pa-4 font-egyptienne"
            >
              {{ $t("no-commercial-info") }}
            </div> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4" class="pl-0">
        <contact-form class="mt-5"></contact-form>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";
import { mapState } from "vuex";
import { mdiEmail } from "@mdi/js";

export default {
  name: "ContactView",
  components: {
    ContactForm,
  },
  data() {
    return {
      mdiEmail,
    };
  },
  computed: {
    ...mapState({
      uniqueContactDetails: (state) => state.clients.uniqueContactDetails,
    }),
  },
};
</script>
